React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')()
Util = require 'lib/util'
HomeSectionHeaderComponent = require 'views/home/home-section-header-component'
HomeBoardSectionBoard = require 'views/home/home-board-section-board'
HomeBoardSectionLinksItem = require 'views/home/home-board-section-links-item'

# take from boards-sidebar-section-view
module.exports = class HomeBoardSection extends React.Component
  displayName: 'HomeBoardSection'

  render: t.renderable ->
    {
      boards
      showOrgName
      sectionName
      numBoardsVisible
      showAll
      onShowMoreClick
      onShowFewerClick
    } = @props

    t.div '.home-board-section', =>
      boards.map (board, index) =>
        if index < numBoardsVisible || showAll
          t.tag HomeBoardSectionBoard, {
            key: board.id
            board
            showOrgName
          }

      if boards.length > numBoardsVisible && !showAll
        t.tag HomeBoardSectionLinksItem, {
          onClick: onShowMoreClick
          icon: 'down'
          text: 'show-more'
        }

      else if showAll
        t.tag HomeBoardSectionLinksItem, {
          onClick: onShowFewerClick
          icon: 'up'
          text: 'show-fewer'
        }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-section.coffee